@if ({ supplier: supplier$ | async, campus: campus$ | async }; as vm) {
  <ion-header class="ion-no-border bg">
    <ion-toolbar>
      @if (mode !== 'update') {
        <ion-buttons slot="start">
          <ion-button (click)="close()">
            <ion-icon slot="icon-only" name="close"></ion-icon>
          </ion-button>
        </ion-buttons>
      }
      <ion-title>Términos y condiciones</ion-title>
    </ion-toolbar>
  </ion-header>
  <ion-content class="ion-no-border bg">
    <form [formGroup]="form">
      @if (showUnderAgeFormControl) {
        <ion-item lines="full">
          <ion-label>
            Por ser menor de edad, es necesario que un padre o un tutor esté presente y autorice el registro. Al
            aceptar, se entiende que fue en presencia del padre o tutor del alumno a registrarse.
          </ion-label>
          <ion-checkbox slot="end" formControlName="underAge"></ion-checkbox>
        </ion-item>
      }
      @if (user?.role === 'Colaborador' && !user?.campus_registered) {
        <ion-item lines="full">
          <ion-label position="stacked">Campus</ion-label>
          <ion-select placeholder="Seleccionar" formControlName="campus">
            @for (item of vm.campus; track item) {
              <ion-select-option [value]="item.id">{{ item.name }}</ion-select-option>
            }
          </ion-select>
        </ion-item>
      }
      <ion-segment scrollable [value]="selectedTab()" (ionChange)="selectedTab.set($any($event.detail.value))">
        <ion-segment-button value="terms">
          <ion-label>Términos y condiciones</ion-label>
        </ion-segment-button>
        <ion-segment-button value="privacy">
          <ion-label>Aviso de privacidad</ion-label>
        </ion-segment-button>
        <ion-segment-button value="student_regulations">
          <ion-label>Reglamento Estudiantil</ion-label>
        </ion-segment-button>
        <ion-segment-button value="disciplinary_conduct">
          <ion-label>Conducta Disciplinaria</ion-label>
        </ion-segment-button>
      </ion-segment>

      @switch (selectedTab()) {
        @case ('terms') {
          <div [innerHTML]="vm.supplier?.terms" class="ion-padding"></div>
        }
        @case ('privacy') {
          <div [innerHTML]="vm.supplier?.privacy" class="ion-padding"></div>
        }
        @case ('student_regulations') {
          <div [innerHTML]="vm.supplier?.student_regulations" class="ion-padding"></div>
        }
        @case ('disciplinary_conduct') {
          <div [innerHTML]="vm.supplier?.disciplinary_conduct" class="ion-padding"></div>
        }
      }
    </form>
  </ion-content>
  <ion-footer>
    <ion-toolbar>
      @if (mode !== 'read') {
        <ion-button expand="block" (click)="acceptTerms()" [disabled]="form.invalid || isLoading()">
          Aceptar términos y condiciones
        </ion-button>
      }
      @if (mode === 'read') {
        <ion-button expand="block" (click)="close()">Cerrar</ion-button>
      }
    </ion-toolbar>
  </ion-footer>
}
